// @flow

import React from 'react';
import type { Node } from 'react';

/*
  Wrap a component with Dismissable to make it conditionally visible based on a local storage key

  const InnerComponent = ({dismiss, hideIfDismissed}) => {
    const onClick = () => {
      dismiss();
      hideIfDismissed();
    };

    return <div onClick={onClick}/>;
  };

  const DismissableComponent = <Dismissable key={'foo'} render={InnerComponent}/>;
*/

export type DismissableProps = {
  storageKeyPrefix: string,
  render: ({
    dismiss: () => void,
    hideIfDismissed: () => void,
    dismissAndHide: () => void,
  }) => Node,
};

type State = {
  dismissed: boolean,
};

class Dismissable extends React.Component<DismissableProps, State> {
  storageKey: string;

  constructor(props: DismissableProps) {
    super(props);
    const { storageKeyPrefix } = props;
    this.storageKey = `${storageKeyPrefix}-dismissed`;
  }

  UNSAFE_componentWillMount() {
    this.hideIfDismissed();
  }

  dismiss = () => {
    localStorage.setItem(this.storageKey, 'true');
  };

  hideIfDismissed = () => {
    const dismissed = localStorage.getItem(this.storageKey) === 'true';
    this.setState({ dismissed: dismissed });
  };

  dismissAndHide = () => {
    this.dismiss();
    this.hideIfDismissed();
  };

  render() {
    if (this.state.dismissed) {
      return null;
    }

    const { dismiss, hideIfDismissed, dismissAndHide } = this;

    return this.props.render({
      dismiss,
      hideIfDismissed,
      dismissAndHide,
    });
  }
}

export default Dismissable;
